import http from '@/plugins/axios_plugin';

class ServiceBanners {

    index() {
        return http.get('/api/banners');
    }

    filtrar(filtro) {
        return http.get('/api/banners', { params: filtro });
    }

    salvar(banner) {
        return http.post('/api/banners/salvar', banner);
    }

    editar(banner_id) {
        return http.get('/api/banners/' + banner_id + '/editar');
    }

    atualizar(banner) {
        return http.post('api/banners/' + banner.id + '/atualizar', banner);
    }

    excluir(banner_id) {
        return http.post('/api/banners/' + banner_id + '/excluir');
    }

    ativos(destino) {
        return http.get('/api/banners/ativos?destino=' + destino);
    }

}

export default new ServiceBanners();